import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './TransactionSuccess.css';

const TransactionSuccess = () => {
  const history = useHistory();
  const location = useLocation();
  const [showLoading, setShowLoading] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    // Show loading animation for 2 seconds, then show success
    const loadingTimer = setTimeout(() => {
      setShowLoading(false);
      setTimeout(() => {
        setShowSuccess(true);
      }, 200);
    }, 2000);

    return () => clearTimeout(loadingTimer);
  }, []);
  
  // Get transaction data from location state if passed
  const transactionData = location.state || {};
  const { amount, recipient, type, note } = transactionData;

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value || 25.50); // Default for demo
  };

  const handleSendAnother = () => {
    history.push('/pay');
  };

  const handleGoHome = () => {
    history.push('/');
  };

  if (showLoading) {
    return (
      <div className="transaction-loading-page">
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
          </div>
          <h3 className="loading-text">Processing your transaction...</h3>
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="transaction-success-page">
      <div className="success-container">
        <div className="success-icon-large">
          <i className="fas fa-check-circle"></i>
        </div>
        
        <h2 className="success-title">
          {type === 'request' ? 'Request Sent!' : 'Payment Sent!'}
        </h2>
        
        <p className="success-subtitle">
          {type === 'request' 
            ? 'Your money request has been sent successfully.' 
            : 'Your payment has been sent successfully.'}
        </p>
        
        <div className="transaction-details">
          <div className="amount-display">
            {formatCurrency(amount)}
          </div>
          
          <div className="recipient-info">
            <span>to {recipient || 'Alice Smith'}</span>
          </div>
          
          <div className="transaction-note">
            "{note || 'Coffee run ☕ Thanks!'}"
          </div>
        </div>
        
        <div className="success-actions">
          <button className="btn-primary" onClick={handleSendAnother}>
            <i className="fas fa-plus"></i>
            {type === 'request' ? 'Send Another Request' : 'Send Another Payment'}
          </button>
          <button className="btn-secondary" onClick={handleGoHome}>
            <i className="fas fa-home"></i>
            Go Home
          </button>
        </div>
        
        <div className="success-footer">
          <p>You can view this transaction in your history.</p>
        </div>
      </div>
    </div>
  );
};

export default TransactionSuccess;